import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { chatSelector, globalStateSelector } from "../../../../../store/selector";
import { chatAction, messageAction } from "../../../../../store/action";
import "./DocumentPicker.css";
import MessageScreenFooter from "../MessageScreenFooter/MessageScreenFooter";
import SelectedImages from "../ImageLibrary/SelectedImages";
import { getUUID } from "../../utils";
import {
  changeLastMessage,
  createChatEvent,
} from "../../../../../dialpad/service/chat.service";
import APIManager from "modules/common/apiManager";
import Header from "../ImageLibrary/Header";

const mAPI = new APIManager();

function DocumentPicker({ selectedDocs: selectedDocsFromRedux, ...props }) {
  const [CurrentPdfIndex, setCurrentPdfIndex] = useState(0);
  const [SelectedAllPdfData, setSelectedAllPdfData] = useState([]);
  const [Active, setActive] = useState(true);
  const [CustomMessage, setCustomMessage] = useState("");

  useEffect(() => {
    console.log("Here is also message ", CustomMessage);
  }, [CustomMessage]);


  useEffect(() => {
    try {
      setSelectedAllPdfData(Array.from(selectedDocsFromRedux));
    } catch (error) {
      console.log("Error in DocumentPicker", error);
    }
  }, [selectedDocsFromRedux]);

  useEffect(() => {
    setActive(false);
    setTimeout(() => {
      setActive(true);
    }, 300);
  }, [CurrentPdfIndex]);

  function convertBytesToKBMBGB(bytes) {
    if (bytes < 1024) {
      return bytes + " B";
    } else if (bytes < 1024 * 1024) {
      return (bytes / 1024).toFixed(2) + " KB";
    } else if (bytes < 1024 * 1024 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(2) + " MB";
    } else {
      return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
    }
  }

  const closeDocumentPicker = () => {
    const { dynamicUpdate } = props;
    dynamicUpdate({ data: { key: `selectedDocs`, value: [] } });
    setCurrentPdfIndex(0);
    setActive(true);
  };

  const resetState = () => {
    const { dynamicUpdate } = props;
    setSelectedAllPdfData([]);
    setCurrentPdfIndex(0);
    dynamicUpdate({ data: { key: `selectedDocs`, value: [] } });
  };

  const getPublicUrl = async (formData, uniqueId) => {
    console.log("sendpostformsent getpublicurl");
    const event = createChatEvent({ id: uniqueId, loading: 0 });
    const { retryDocument, dynamicUpdate } = props;
    window.dispatchEvent(event);
    return new Promise((res, rej) => {
      mAPI.sendPostForm(
        `chat/upload`,
        formData,
        (data) => {
          console.log("sendpostformsent", data);
          res(data);
        },
        (errorCode, data) => {
          console.log("Chat/upload", errorCode, data);
          const event = createChatEvent({ id: uniqueId, success: false });
          window.dispatchEvent(event);
          let newArray = [];
          if (
            retryDocument &&
            Array.isArray(retryDocument) &&
            retryDocument.length > 0
          ) {
            newArray = [...retryDocument];
          }
          dynamicUpdate({
            data: {
              key: `retryDocument`,
              value: [
                ...newArray,
                {
                  file: selectedDocsFromRedux[0],
                  uniqueId,
                  status: "pending",
                },
              ],
            },
          });
        },
        "private",
        (data) => {
          const progress = Math.round((100 * data.loaded) / data.total);
          const event = createChatEvent({ id: uniqueId, loading: progress });
          window.dispatchEvent(event);
        }
      );
    });
  };


  const sendMessage = async (e) => {
    const uniqueId = getUUID();
    const {
      configProcessor,
      messageList,
      assignedList,
      selectedAssignedList,
      dynamicUpdate,
      currentUser,
    } = props;
    const mimeType = SelectedAllPdfData[0].type;
    const commonPayload = {
      from: "agent",
      timeStamp: new Date().toISOString(),
      // here are sending type mean doc
      type: "document",
      content: {
        // here we are sending one pdf only
        link: URL.createObjectURL(SelectedAllPdfData[0]),
        mimeType: mimeType,
        fileName: SelectedAllPdfData[0].name,
        fileSize: SelectedAllPdfData[0].size,
        caption: CustomMessage,
      },
      id: uniqueId,
      loading: 0,
    };
    const messageData = {
      userId: currentUser.userId,
      timeStamp: new Date().toISOString(),
      agent: {
        email: currentUser.email,
        name: currentUser.name,
        role: currentUser.role,
        userId: currentUser.userId,
        username: currentUser.user_name,
      },
      message: commonPayload,
    };

    dynamicUpdate({
      data: {
        key: `messageList.${selectedAssignedList.identifier}`,
        value: [
          messageData,
          ...(messageList[selectedAssignedList.identifier] || []),
        ],
      },
    });
    resetState();


    const formData = new FormData();
    formData.append("file", SelectedAllPdfData[0]);
    const data = await getPublicUrl(formData, uniqueId, selectedAssignedList.identifier);
    console.log({ data });
    const messagePayload = {
      ...commonPayload,
      content: {
        ...data,
        mimeType: mimeType,
        caption: CustomMessage,
      },
    };
    configProcessor("sendPayload", {
      ...selectedAssignedList,
      payloadType: "message",
      "rmq:pattern": "agent:message",
      message: {
        ...(selectedAssignedList && selectedAssignedList.message),
        ...messagePayload,
      },
    });

    changeLastMessage({
      list: assignedList,
      identifier: selectedAssignedList.identifier,
      receivedMessage: messagePayload,
      key: "assignedList",
    });
    closeDocumentPicker();
  };
  if (SelectedAllPdfData && SelectedAllPdfData.length == 0) {
    return null;
  }

  return (
    <div className="document-picker_main">
      <div className="document-picker_header">
        <Header
          name={
            (SelectedAllPdfData &&
              SelectedAllPdfData[CurrentPdfIndex] &&
              SelectedAllPdfData[CurrentPdfIndex].name) ||
            ""
          }
          size={
            (SelectedAllPdfData &&
              SelectedAllPdfData[CurrentPdfIndex] &&
              SelectedAllPdfData[CurrentPdfIndex].size) ||
            0
          }
          onClose={closeDocumentPicker}
        />
      </div>
      <div className="document-picker_body">
        <div
          className="document-picker-body_close"
          onClick={() => closeDocumentPicker()}
        ></div>
        <img
          src={"/images/defalutDocument.svg"}
          className={` ${Active ? "active" : "non-active"
            } document-picker_image_size`}
          alt=" "
          width={350}
          style={{ maxWidth: '50vw', maxHeight: '50vh' }}
        />
        <SelectedImages
          selectedImages={SelectedAllPdfData}
          selectImage={setCurrentPdfIndex}
          type={"document"}
          covertBytesToKBMBGB={convertBytesToKBMBGB}
        />
      </div>
      <div className="position-absolute w-100 bottom-0">
        <MessageScreenFooter
          showAttachBtn={false}
          customSendMessage={sendMessage}
          setIsFileAttached={true}
          setCustomMessage={setCustomMessage}
        // hideInput={true}
        />
      </div>
    </div>
  );
}

const stateToProps = (state) => ({
  selectedAssignedList: chatSelector.getChatDynamic(
    state,
    "selectedAssignedList"
  ),
  messageList: chatSelector.getChatDynamic(state, "messageList"),
  assignedList: chatSelector.getChatDynamic(state, "assignedList"),
  selectedDocs: chatSelector.getChatDynamic(state, "selectedDocs"),
  retryDocument: chatSelector.getChatDynamic(state, "retryDocument"),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = (dispatch) => ({
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (type, messageData) => {
    dispatch(chatAction.dynamicUpdate(type, messageData));
  },
});
export default connect(stateToProps, dispatchToProps)(DocumentPicker);

// const [Loading, setLoading] = useState(false);
// const [ImageDataUrl, setImageDataUrl] = useState(false);

// const readAndAppendPdfData = async (file) => {
//   return new Promise((resolve) => {
//     const reader = new FileReader();

//     reader.onload = (e) => {
//       const arrayBuffer = e.target.result;
//       resolve(arrayBuffer);
//     };
//     reader.onerror = (e) => {
//       console.log('Error while reading PDF', e);
//       setLoading(false);
//     };
//     reader.readAsArrayBuffer(file);
//   });
// };

// const MainPreview = (pdfData) => {
//   const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
//   const pdfDataUrl = URL.createObjectURL(pdfBlob);
//   const canvas = document.createElement('canvas');
//   const context = canvas.getContext('2d');
//   console.log("Till that all ok");
//   const pdfImage = new Image();
//   pdfImage.onload = () => {
//     canvas.width = pdfImage.width;
//     canvas.height = pdfImage.height;
//     context.drawImage(pdfImage, 0, 0);
//     const imageDataUrl = canvas.toDataURL('image/png');
//     setImageDataUrl(imageDataUrl);
//     setLoading(false);
//   };2.96 KB

//   pdfImage.onerror = (e) => {
//     console.log('Error while loading PDF',e);
//     setLoading(false);
//   };
//   pdfImage.src = pdfDataUrl;
// }

// const handleSelectedDocs = async () => {
//   setLoading(true);
//   const pdfDataArray = [];
//   for (const selectedFile of selectedDocsFromRedux) {
//     const pdfData = await readAndAppendPdfData(selectedFile);
//     pdfDataArray.push(pdfData);
//   }
//   setSelectedAllPdfData(pdfDataArray);
//   MainPreview(selectedDocsFromRedux[0]);
// };

// useEffect(()=>{

//   if( Array.isArray(selectedDocsFromRedux) && selectedDocsFromRedux.length > 0  )
//   {
//     handleSelectedDocs();
//   }
// },[selectedDocsFromRedux])



// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/DocumentLibrary/DocumentPicker.js